import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/askpaul_web/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/askpaul_web/src/app/components/layout-widgets/search/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/components/layouts/css/OrderLayout.css");
;
import(/* webpackMode: "eager", webpackExports: ["SearchPage"] */ "/var/www/askpaul_web/src/app/components/search/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/askpaul_web/src/app/search/index.css");
